import { gql, useQuery } from '@apollo/client'

const QUERY_FILTERED_FEATURES = gql`
  query filteredFeatures($tagObjectInput: [TagObjectInput!]!) {
    filteredFeatures(tagObjectInput: $tagObjectInput) {
      featureId
      featureName
      featureType
      featureFieldType
    }
  }
`

export const useFilteredFeatures = (filter) => {
  const { data, ...rest } = useQuery(QUERY_FILTERED_FEATURES, {
    variables: { tagObjectInput: filter },
    skip: !filter?.length,
  })
  return { data: data?.filteredFeatures, ...rest }
}
